import { prop } from 'datx';

import { MoreMagicType } from '../../enums/MoreMagicType';
import { BaseModel } from './BaseModel';

export class Upload extends BaseModel {
  public static type = 'upload';

  @prop
  public id!: number;

  @prop
  public path!: string;

  @prop
  public type!: MoreMagicType;
}
